import React, { Component } from 'react';
import { PaginationProvider, PaginationContext } from './PaginationContext';
import Switcher from './Switcher';
import ResultText from './ResultText';
import SeeMore from './SeeMore';

export type Props = PaginationContext;

class Pagination extends Component<Props> {
  static Switcher: typeof Switcher;

  static SeeMore: typeof SeeMore;

  static ResultText: typeof ResultText;

  render(): JSX.Element {
    const { totalRecords, currentPage, pageLimit, defaultResultSizeOptions, children, onPageChanged } = this.props;

    return (
      <PaginationProvider
        totalRecords={totalRecords}
        pageLimit={pageLimit}
        currentPage={currentPage}
        defaultResultSizeOptions={defaultResultSizeOptions}
        onPageChanged={onPageChanged}
      >
        {children}
      </PaginationProvider>
    );
  }
}

Pagination.Switcher = Switcher;
Pagination.SeeMore = SeeMore;
Pagination.ResultText = ResultText;

export default Pagination;
